import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { StatusAPI } from "./../../../apis/StatusAPI";
import isLoggedIn from "./../../../utils/isLoggedIn";
import userContext from "./../../../context/userContext";
import StatusItem from "./StatusItem"
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import AddStatusForm from "./AddStatusForm";


const AllTicketStatus = () => {
    const navigate = useNavigate();
    const { userLoggedIn } = useContext(userContext);
    const [isLoading, setIsLoading] = useState(true)
    const [apiErr, setApiErr] = useState()
    const [allStatus, setAllStatus] = useState();
    const [displayAddForm, setDisplayAddForm] = useState(false);


    const getStatus = () => {
        StatusAPI.getAllStatus().then((response) => {
            setIsLoading(false)
            setAllStatus(response.data)
        })
            .catch(() => {
                setIsLoading(false)
                setApiErr("Une erreur est survenue")
            });
    };

    useEffect(
        () => {
            if (userLoggedIn.roles[0] !== "ROLE_ADMIN") navigate("/profil");
            document.title = "Devolie - Les statuts ticket"
            if (!isLoggedIn()) {
                navigate("/");
            } else {
                getStatus();
            }
        },
        []
    );

    return (
        <>
            <div>
                <div className="header-with-cta">
                    <h2>Les statuts Ticket</h2>
                    <button onClick={() => setDisplayAddForm(true)} className="btn btn-primary create-item-btn"><AddOutlinedIcon />Ajouter</button>
                </div>
                <hr />
                {isLoading && (
                    <p className="loading">Chargement...</p>
                )}
                {apiErr && (
                    <p className="loading">Une erreur est survenue.</p>
                )}

                {!isLoading && allStatus && allStatus.length > 1 && (
                    <ul>
                        {allStatus.map(status => <StatusItem status={status} setAllStatus={setAllStatus}  key={status.id} />)}
                    </ul>
                )}
                
                {!isLoading && allStatus && !Array.isArray(allStatus) && (
                    <ul>
                        <StatusItem priority={allStatus} setAllStatus={setAllStatus} />
                    </ul>
                )}

            </div>
            {
                displayAddForm && <AddStatusForm setDisplayAddForm={setDisplayAddForm} setAllStatus={setAllStatus} />
            }

        </>
    );
};

export default AllTicketStatus;